// Admin API client — /admin/audit-test/* (mirrors the API's audit-test aggregate).

import type {
  AuditTestRun,
  AuditTestRunCycle,
  AuditTestRunRequest,
  AuditSkipCacheOptions,
} from '@a7y/types';
import type { LegacyV1AuditShape } from '@/types/legacyV1Audit';
import { client } from './transport';

export const auditTestApi = {
  // Audit Testing
  getAuditTestLatest: async () => {
    const res = await client.get<{ runs: AuditTestRun[] }>('/audit-test/latest');
    return res.runs;
  },
  getAuditTestRuns: async (params?: {
    limit?: number;
    offset?: number;
    appName?: string;
    platform?: string;
    runGroupId?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.appName) searchParams.set('appName', params.appName);
    if (params?.platform) searchParams.set('platform', params.platform);
    if (params?.runGroupId) searchParams.set('runGroupId', params.runGroupId);
    const res = await client.get<{ runs: AuditTestRun[] }>(`/audit-test/runs?${searchParams}`);
    return { data: res.runs ?? [], total: res.runs?.length ?? 0 };
  },
  getAuditTestRun: async (runId: string) => {
    const res = await client.get<{ run: AuditTestRun }>(`/audit-test/runs/${runId}`);
    return res.run;
  },
  getAuditTestRunCycles: async (params?: { limit?: number; offset?: number }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.offset) searchParams.set('offset', String(params.offset));
    const res = await client.get<{ cycles: AuditTestRunCycle[]; total: number }>(
      `/audit-test/run-cycles?${searchParams}`
    );
    return res;
  },
  triggerAuditTestBatch: (skipCacheOptions?: AuditSkipCacheOptions) =>
    client.post<{ runGroupId: string; runs: Array<{ appName: string; platform: string }> }>(
      '/audit-test/run-batch',
      {
        skipCacheOptions,
        triggerSource: 'manual',
      }
    ),
  triggerAuditTest: (data: AuditTestRunRequest) =>
    client.post<{ runGroupId: string; status: string }>('/audit-test/run', data),
  getAuditTestAuditResult: (auditId: string) =>
    client.get<LegacyV1AuditShape>(`/audit-test/audit-result/${auditId}`),
};
